const nativeContextMenuTargetSelector =
  'input, textarea, [contenteditable]:not([contenteditable="false"]), .ProseMirror, [role="textbox"]';

export const isNativeContextMenuTarget = (target: EventTarget | null): boolean =>
  target instanceof Element && target.closest(nativeContextMenuTargetSelector) !== null;
